import { merge } from "lodash";
import addressModuleGetters from "./addressModule/getters";
import shipmentModuleGetters from "./shipmentModule/getters";
import carrierModuleGetters from "./carrierModule/getters";

export default merge(addressModuleGetters, shipmentModuleGetters, carrierModuleGetters);
